import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One request per page load, shared by Hero, Gallery and Backdrops.
let cache = null;

export const fetchSiteImages = () => {
  if (!cache) {
    cache = axios
      .get(`${API}/site-images`)
      .then((r) => r.data)
      .catch(() => ({ hero: "", gallery: [], categories: {} }));
  }
  return cache;
};

export const useSiteImages = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetchSiteImages().then(setData);
  }, []);
  return data;
};
